import type { QueryKey } from '@tanstack/react-query';
import { PaginationParams } from 'lib/api';
import { MetricParams } from './types';

export default {
  byFilterValues: (pathname: string, params: Partial<MetricParams & PaginationParams>) =>
    [pathname, params?.project_id, params?.name, params?.group_id, params?.offset, params?.limit] as QueryKey,
  getMetricDetails: (id: number) => ['metric', id] as QueryKey,
};
